import React from 'react'
import { DialogActions } from '@mui/material'

interface ModalFooterProps {
  footerContent: React.ReactNode // Define the type for footerContent prop
}

const ModalFooter: React.FC<ModalFooterProps> = ({ footerContent }) => {
  return <DialogActions>{footerContent}</DialogActions>
}

export default ModalFooter
